module.exports = __webpack_public_path__ + "PTMETTAcontact-3.b401b95b.png";